export default {
  username: [{ type: 'empty' }],
  password: [{ type: 'empty' }, { type: 'passwordCriteria' }],
  confirmPassword: [{ type: 'empty' }, { type: 'passwordCriteria' }],
  email: [{ type: 'empty' }, { type: 'email' }],
};
